/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { format } from "date-fns";
import { notificarErroApi } from "utils/alertaCiencia";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  idUnidade: string;
  idLeadCorretor: string;
  idOportunidade: string;
}

export function useAlterarProposta() {
  const putData = async (props: Props) => {
    const ALTERAR_PROPOSTA = `${backofficeEnviroment}/common/oportunidades-lead/alterar-proposta/vivaz/v1/${props.idLeadCorretor}/${props.idUnidade}/${props.idOportunidade}`;
    const { data } = await instance.put(ALTERAR_PROPOSTA, {
      IdUnidade: props.idUnidade,
      IdLeadCorretor: props.idLeadCorretor,
      IdOportunidade: props.idOportunidade,
    });
    return data;
  };

  const mutation = useMutation(putData, {
    onSuccess: () => {
      // toast.success("Proposta alterada com sucesso!");
    },
    onError: (error: any) => {
      notificarErroApi("Erro ao alterar proposta", error);
    },
  });

  return mutation;
}
